import { Layout, Icon, Button, message } from "antd";
import UserListContainer from "./UserList/container";
import { Modal } from "react-bootstrap";

import SideBar from "../../../components/SideBar/container";
import React, { useState } from "react";

const { Header, Content, Footer } = Layout;

function BlogCollection(props) {
  const [open, setOpen] = useState(false);

  function onSubmit(e) {
    if (props.userExist === "existsnot") {
      props.addUser(props.email, props.rolle, props.name);
      setOpen(false);
      message.success("Brugeren er oprettet!", 5);
      return true;
    } else {
      e.preventDefault();
      return false;
    }
  }

  return (
    <Layout style={{ height: "100vh" }}>
      <Modal show={open} onHide={() => setOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Opret bruger</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
          title='user-collection'
            style={{ visibility: "hidden" }}
            width="0"
            height="0"
            border="0"
            name="dummyfram"
            id="dummyfram"
          />

          <form
            target="dummyfram"
            class="form-horizontal"
            onSubmit={e => onSubmit(e)}
          >
            <p>
              <label>Email</label>
              <div>
                <input
                  style={{ position: "relative" }}
                  onChange={e => props.updateUser({ email: e.target.value })}
                  class="form-control"
                  id="emailID"
                  type="email"
                  name="email"
                  required
                />

                {props.userExist === "existsnot" ? (
                  <Icon
                    type="check"
                    style={{
                      position: "absolute",
                      right: "30px",
                      top: "84px",
                      color: "green"
                    }}
                  />
                ) : props.userExist ? (
                  <Icon
                    type="close"
                    style={{
                      color: "red",
                      position: "absolute",
                      right: "30px",
                      top: "84px"
                    }}
                  />
                ) : (
                  <Icon
                    type="loading"
                    style={{
                      position: "absolute",
                      right: "30px",
                      top: "84px"
                    }}
                  />
                )}
              </div>
            </p>
            <p>
              <label>Navn</label>
              <input
                onChange={e => props.updateUser({ name: e.target.value })}
                style={{ position: "relative" }}
                class="form-control"
                id="nameID"
                type="name"
                name="name"
                required
              />
              <label>Rolle</label>
              <select
                name="role"
                onChange={e => props.updateUser({ role_add: e.target.value })}
                class="form-control"
                id="roleID"
              >
                <option value="test">TA</option>
                <option value="admin">Admin</option>
              </select>

              <input type="hidden" name="language" value={props.language} />
            </p>
            <p class="full">
              <Button htmlType="submit">Opret</Button>
            </p>

            <p style={{ fontSize: "small" }}>
              Bemærk: Ved tryk af "Opret" sendes der en TA invitation hvis TA er
              valgt
            </p>
          </form>
        </Modal.Body>
      </Modal>

      <SideBar />
      <Layout>
        <Header
          style={{
            textAlign: "left",
            background: "#fff",
            padding: "0 24px",
            borderBottom: "1px solid"
          }}
        >
          <h1>Users</h1>
          <Button
            type="primary"
            onClick={() => setOpen(true)}
            style={{
              right: "24px",
              top: "14px",
              position: "absolute"
            }}
          >
            Add User
          </Button>
        </Header>
        <Content style={{ backgroundColor: "#fff" }}>
          <div
            style={{ padding: "40px 24px", background: "#fff", minHeight: 360 }}
          >
            <UserListContainer />
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>iLead © 2018</Footer>
      </Layout>
    </Layout>
  );
}

export default BlogCollection;



// WEBPACK FOOTER //
// ./src/pages/Admin/UsersCollection/index.js